"use client";
import { Stage } from "@/types/productTypes";
import { useEffect } from "react";
import OptionPairManager from "../../ReactFlow/OptionPairGraph";
import { useAdminStore } from "../../../../store/useAdminStore";

type ImageEditorProps = {
   stage: Stage;
};

export default function ImageEditor({ stage }: ImageEditorProps) {
   const { allImages, currentOptionPair, ...adminStore } = useAdminStore();

   useEffect(() => {
      if (!stage.id) return;
      adminStore.fetchImages();
   }, [stage]);

   useEffect(() => {
      if (!stage.id) return;
      console.log("stage.id", stage.id);
      adminStore.fetchOptionPair(stage.id);
   }, [stage.id]);

   useEffect(() => {
      console.log("optionPair", currentOptionPair);
   }, [currentOptionPair]);

   return (
      <div className="flex w-full h-full bg-gray-50">
         {/* LEFT SIDEBAR: Unused images + upload */}

         <div className="h-full overflow-y-auto w-full">
            {currentOptionPair?.id && (
               <OptionPairManager optionPairId={currentOptionPair?.id} />
            )}
         </div>
      </div>
   );
}
